<!-- Small "Copy" button next to a label of the second tab (SeoPanel.vue); the panel copies on click -->
<script setup lang="ts">
import { useI18n } from '../../composables/useI18n'

defineProps<{ label?: string }>()
const emit = defineEmits<{ click: [] }>()
const { t } = useI18n()
</script>

<template>
  <button type="button" class="text-[11px] font-bold text-brand hover:underline normal-case tracking-normal" @click="emit('click')"><i class="fas fa-copy mr-1"></i>{{ label || t('Copy') }}</button>
</template>
